import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TradingViewChart from './TradingView';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <TradingViewChart />
  </React.StrictMode>
);
